
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, Container, Paper } from '@mui/material';
import { SentimentDissatisfied as SadIcon } from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <SadIcon sx={{ fontSize: 100, color: 'text.secondary', mb: 2 }} />
        
        <Typography variant="h1" component="h1" fontWeight="bold">
          404
        </Typography>
        
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4, maxWidth: 600 }}>
          The page you are looking for doesn't exist or has been moved.
          Please check the URL or navigate back to the homepage.
        </Typography>
        
        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to="/"
          >
            Go to Homepage
          </Button>
          
          <Button
            variant="outlined"
            component={RouterLink}
            to="/docs"
          >
            View Documentation
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;
